<template>
  <div class="table-all">
    <div class="table-utilities" :style="{'left':getSideNavigationWidth+'px'}">
      <div class="table-utility">
        Selected: {{$refs?.json_table?.getSelectedSize()}} / {{merged_data?.length}}
      </div>
      <div class="table-utility">
        Visible: {{$refs?.json_table?.render_rows.length}} / {{merged_data?.length}}
      </div>
      <div class="table-utility" v-if="$refs.json_table">
        <dialog ref="download_model" class="download-modal">
          <section class="download-options">
            <Radio :preset="1" @change="handleDownloadRadioChange($event)" ref="radio" label="Select entries for download" :options="download_options"/>
          </section>
          <section class="download-button">
          <button class="download" @click.prevent="closeDownloadModal()">Close</button>
          <template v-if="download_radio_value!==undefined && download_radio_value!==null">
            <JSONToCSV v-if="download_radio_value===0" :loading="all_data==null" :columns="columns" :data="all_data" :filename="filename"/>
            <JSONToCSV v-if="download_radio_value===1" :columns="columns" :data="data" :filename="filename"/>
            <JSONToCSV v-if="download_radio_value===2" :columns="columns" :data="$refs.json_table.render_rows" :filename="filename"/>
            <JSONToCSV v-if="download_radio_value===3 && select" :columns="columns" :data="getSelected()" :filename="filename"/>
          </template>
          <JSONToCSV v-else :columns="columns" :data="null" :filename="filename"/>
          </section>
        </dialog>
        <button class="download" @click.prevent="openDownloadModal()">Download</button>
      </div>
      <div class="table-utility" v-if="search">
        <Search @enter="enter($event)"/>
      </div>
      <div class="table-utility">
        <input :placeholder="placeholder" class="filter-input" type="text" :value="modelValue" @input="$emit('update:modelValue', $event.target.value)">
      </div>
    </div>
    <div class="table-paginate">
      <div class="paginator" v-if="n_pages>1" :style="{'left':getSideNavigationWidth+'px'}">
        <button @click.prevent="setPage(1)" class="page" :class="{'grid-1':current_page>3,'grid-2':current_page===3,'grid-3':current_page===2}"  v-if="current_page>1">1</button>
        <div  class="page grid-2" v-if="current_page>3">...</div>
        <button  @click.prevent="setPage(current_page-1)" class="page grid-3" v-if="current_page>2">{{current_page - 1}}</button>
        <button disabled class="page grid-4" >{{current_page}}</button>
        <button @click.prevent="setPage(current_page+1)" class="page grid-5"  v-if="current_page<n_pages-1">{{current_page + 1}}</button>
        <div class="page grid-6"  v-if="current_page<n_pages-2">...</div>
        <button @click.prevent="setPage(n_pages)" class="page grid-7"  v-if="current_page<n_pages">{{n_pages}}</button>
      </div>
    </div>
    <div class="table" v-if="merged_data && merged_data.length>=0">
      <JSONToTable :annotate_by_id="annotate_by_id" :annotate="annotate" :highlight_by_id="highlight_by_id" @option="handleOption($event)" :loading="loading" :self_order="self_order" @order="order($event)" ref="json_table" :data="dataMap(merged_data,columns)" :columns="columns" :select="select" :search_string="filter ? modelValue : null" :rows_per_page="merged_data.length" :row_options="row_options" :dataset_permission="dataset_permission"/>
    </div>
    <dialog class="select-dialog" ref="select_dialog">
      <section class="select-options">
        <Radio ref="radio" :preset="0" label="Choose how to handel selections" :options="[{id:0,label:'Keep selected'},{id:1,label:'Clear selected'}]"/>
      </section>
      <section class="select-button">
        <button class="button" @click.prevent="closeSelectWarning(false)">Cancel</button>
        <button class="button" @click.prevent="closeSelectWarning(true)">Confirm</button>
      </section>
    </dialog>
  </div>
</template>

<script>
import Search from '@/components/table/Search.vue'
import JSONToTable from '@/components/table/JSONToTable.vue'
import JSONToCSV from '@/components/table/JSONToCSV.vue'
import Radio from '@/components/inputs_23/Radio.vue'

export default {
  name: 'TableAll',
  components: {
    JSONToTable,
    JSONToCSV,
    Radio,
    Search,
  },
  props: {
    // Array of table data each
    // Each entry is of the form {id1: val1, id2: val2, ...}
    // Each id uniquely identifies the column
    // Only values with an id corresponding to an id in the columns prop are displayed
    data: Array,

    // Array of the tables header
    // Columns are displayed in the order they are listed
    // id: [string,array[string]]identifyer to select entry from data rows
    // name: [string] name to be displayed in column header
    // show: [boolean] controlling if column is displayed or not
    // nested: [boolean] controlling if id is for nested data
    // Each entry is of the form {id: column_id, name: column_name, show: Boolean, nested: Boolean}
    columns: Array,

    // Show / Hide column for row selection
    select: {
      type: Boolean,
      default: false,
    },
    getSideNavigationWidth: Number,
    annotate_by_id: Boolean,
    annotate: Object,
    rows_per_page: {
      type: Number,
      default: 50,
    },
    row_options: {
      type: Array,
      default: ()=>[],
    },
    highlight_by_id: Boolean,
    placeholder: String,
    modelValue: String,
    dataset_permission: Number,
    filter: Boolean,
    filename: String,
    n_pages: Number,
    self_order:Boolean,
    loading: Boolean,
    search: {
      type: Boolean,
      default: true,
    },
    dataMap: {
      type: Function,
      default: (e)=>e,
    },
  },
  data() {
    return {
      current_page: 1,
      all_data: null,
      promise: null,
      select_close_resolve: null,
      watch: null,
      selected: null,
      download_radio_value: 1,
    }
  },
  watch: {
    // async current_page(to,from) {
    //   console.log(to,from)
    //   if(to===this.watch) {
    //     return
    //   }
    //   const proceed = await this.checkSelected()
    //   if(!proceed) {
    //     this.current_page=from
    //     this.watch=from
    //     return
    //   }
    //   console.log('asdf')
    //   this.$emit('page',to)
    // },
    $route(to) {
      this.setPage(to.query.page,false)
    },
  },
  computed: {
    merged_data() {
      let data = []

      if(!this.select || this.selected===null || this.selected.length<1) {
        data = this.data
      } else {
        data = this.selected.concat(this.data.filter(row=>!this.selected.map(selected=>selected.id).includes(row.id)))
      }

      return data
    },
    download_options() {
      console.log(this.getSelectedSize())
      const options = [
        // {id:0,label:`<div style="display:flex;width:100%;"><span>All entries</span><span style="margin-left:auto;">(~${this.rows_per_page*this.n_pages} entries)</span></div>`},
        // {id:1,label:`<div style="display:flex;width:100%;"><span>Current page</span><span style="margin-left:auto;">(${this.data.length} entries)</span></div>`},
        // {id:2,label:`<div style="display:flex;width:100%;"><span>Filtered</span><span style="margin-left:auto;">(${this.$refs.json_table.render_rows.length} entries)</span></div>`},
      ]
      // if(this.select) {
      //   options.push({id:3,label:`<div style="display:flex;width:100%;"><span>Selected</span><span style="margin-left:auto;">(${this.getSelectedSize()} entries)</span></div>`})
      // }
      return options
    }
  },
  mounted()  {
    this.setPage(this.$route.query.page,false)
  },
  methods: {
    handleOption(event) {
      this.$emit('option',event)
    },
    setPage(page,emit=true) {
      if(!page) {
        this.current_page = 1
      } else {
        this.current_page = parseInt(page)
      }
      if(emit) {
        this.$emit('page',this.current_page)
      }
    },
    setOrder(order) {
      this.$refs.json_table.setOrder(order)
    },
    handleDownloadRadioChange(value) {
      this.download_radio_value = value
      if(value===0) {
        this.all_data = null
        this.$emit('downloadAll')
      }
    },
    closeSelectWarning(proceed) {
      this.$refs.select_dialog.close()
      this.select_close_resolve({proceed,value:this.$refs.radio.value})
    },
    async checkSelected() {
      if(this.$refs.json_table && this.$refs.json_table.getSelectedSize()>0) {
        this.$refs.select_dialog.showModal()
        var resolver;
        var popupClosed = new Promise(function (resolve) {
          resolver = resolve
        })
        this.select_close_resolve = resolver

        const popup = await popupClosed
        if(!popup.proceed) {
          return false
        } else {
          if(popup.value===0) {
            this.selected = this.$refs.json_table.getSelected()
            this.$refs.json_table.setSelected(Array.from(Array(this.selected.length).keys()))
          } else {
            this.selected = []
            this.$refs.json_table.clearSelected()
          }
        }
      } else {
        this.selected = []
      }

      return true
    },
    setSelected(values) {
      this.$refs.json_table.setSelected(values)
    },
    getSelected() {
      return this.$refs.json_table.getSelected()
    },
    clearSelected() {
      this.$refs.json_table.clearSelected()
    },
    getSelectedSize() {
      return this.$refs.json_table.getSelectedSize()
    },
    closeDownloadModal() {
      this.$refs.download_model.close()
    },
    openDownloadModal() {
      this.$refs.download_model.showModal()
      this.$refs.download_model.addEventListener("mousedown", e=>{
        const dialog_rect = this.$refs.download_model.getBoundingClientRect()
        if(e.clientX < dialog_rect.left || e.clientX > dialog_rect.right || e.clientY < dialog_rect.top || e.clientY > dialog_rect.bottom) {
          this.closeDownloadModal()
        }
      })
    },
    async order(event) {
      const proceed = await this.checkSelected()
      if(!proceed) {
        return
      }
      this.$emit('order',event)
    },
    async enter(event) {
      const proceed = await this.checkSelected()
      if(!proceed) {
        return
      }
      this.$emit('search',event)
    }
  }
}
</script>

<style lang="scss" scoped>
@import 'D:\\inetpub\\MPortal\\src\\_variables';
.select-dialog {
  border: 1px solid black;
  min-width: 105mm;
  padding: 16px;
  .select-options {
  }
  .select-button {
    display: flex;

    >:last-child {
      margin-left: auto;
    }
    height: 42px;
  }
}
.download-modal {
  border: 1px solid black;
  min-width: 105mm;
  padding: 16px;
  .download-options {
  }
  .download-button {
    display: flex;

    >:last-child {
      margin-left: auto;
    }
    height: 42px;
  }
}
.download {
  cursor: pointer;
  height: 42px;
  aspect-ratio: 21/9;
  cursor: pointer;
  // border: 1px solid gray;
  // color: gray;
  display: flex;
  justify-content: center;
  align-items: center;
  text-decoration: none;
  border: 1px solid $text_dark;
  color: $text_dark;
  &:hover {
    background-color: $text_dark;
    color: $text_light;
  }
}
.table-utilities {
  position: sticky;
  width: 700px;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 1rem;
  padding: .5rem;
  > * {
    height: 42px;
  }
}
.table-utility {
  display: flex;
  justify-content: center;
  align-items: center;
}
.filter-input {
  height: 100%;
  font-size: 1rem;
  padding: 0 1rem;
}
.paginator {
  position: sticky;
  width: 200px;
  left: var(--from_left);
  display: grid;
  grid-template-columns: repeat(7,32px);
  gap: 2px;
  button {
    cursor: pointer;
    border: 1px solid #ccc;
    border-radius: 4px;
    &:hover {
      &:not(:disabled) {
        background-color: #ddd;
      }
    }
  }
  .page {
    display: flex;
    justify-content: center;
    align-items: center;
    aspect-ratio: 1;
    width: 32px;

  }
  .grid-1 {
    grid-column: 1/2;
  }
  .grid-2 {
    grid-column: 2/3;
  }
  .grid-3 {
    grid-column: 3/4;
  }
  .grid-4 {
    grid-column: 4/5;
    background-color: $kit_green;
    color: white;
  }
}
</style>